<!-- 角色设置从表 -->
<template>
  <div>
    <Table
      ref="table"
      :loadObj='{}'
      :option="{}"
      :colObj='{
        opId:"10",
        dataClass:2,
        name:"权限角色授权(按权限)",
        parentId:"TEAM_ID",
        parentName:"权限角色设置",
        parentPath:"/system/userGroup",
        addForm:{
          TEAM_ID:$route.query.TEAM_ID,
        },
        addClick
      }'
    >
    </Table>
    <wx-select
      ref="wxSelect"
      :visible.sync="selector"
      :select='{
        searchslottitle: "请选择用户",
        searchslotId: 100,
        searchslotkey: { ID: "USER_ID", $ID: "USER_NAME" },
        multiple: true,
        loadObj: {
          filterWhere: $route.query.TEAM_ID,
          colname: "ROLE_TEAM",
        },
      }'
      @return="fn"
    ></wx-select>
  </div>
</template>

<script>
import { addShow } from "@/api/table/table";
import wxSelect from "@/components/table/wxSelect";
import Table from '@/components/table/dataTablecSon';
export default {
  components: {
    wxSelect,
    Table,
  },
  data() {
    //这里存放数据
    return {
      selector:false,
      firstEnter:true,
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    // 点击新增
    addClick(){
      this.selector = true;
      this.$refs.wxSelect.selectDataFn([]);
      this.$refs.wxSelect.onLoad();
    },
    // 选择器回调
    fn(param) {
      console.log(param);
      this.selector = false;
      if (param.length === 0) return;
      this.loading = true;
      let arr = param.map((it) => {
        return it.id;
      });
      addShow({
          data: {
            USER_ID: arr.join(","),
            TEAM_ID: this.$route.query.TEAM_ID,
          },
          teamId: this.$route.query.TEAM_ID,
          otherCol: "USER_ID",
          runId: this.$route.query.runId,
          opid: 10,
          dataClass: 2,
      }).then(
        (res) => {
          // console.log(res);
          this.loading = false;
          this.$message.success("操作成功")
          this.$refs.table.$refs.child.onLoad();
        },
        (err) => {
          this.loading = false;
        }
      );
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  activated() {
    if(this.firstEnter){
      this.firstEnter=false;
    }else{
      this.$refs.table.$refs.child.onLoad();
    }
  }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
</style>